/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Only_Glad_Gecko_TasteInputs */

const fr_only_glad_gecko_taste = /** @type {(inputs: Only_Glad_Gecko_TasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder la séance`)
};

/**

* @param {Only_Glad_Gecko_TasteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const only_glad_gecko_taste = /** @type {((inputs?: Only_Glad_Gecko_TasteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Only_Glad_Gecko_TasteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_only_glad_gecko_taste(inputs)
});